import { useState } from 'react';
import styled from 'styled-components';
import { Spacing16 } from 'autogen/design-tokens/tokens';
import Image from 'components/generic/Image';
import Tag from 'components/generic/tag';
import useVideoThumbnail from 'components/video/hooks/useVideoThumbnail';
import type { IVideo } from 'components/video/shared/types';
import VideoPlayer from 'components/video/VideoPlayer';
import dynamic from 'helpers/dynamic';

const Overlay = styled.div`
    display: block;
    position: relative;
    width: 100%;
    height: 100%;
`;

const ImageContainer = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
`;

const StyledImage = styled(Image)`
    width: 100%;
    height: 100%;
    object-fit: cover;
`;

const ButtonContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const PlayButton = styled.button`
    background: none;
    border: none;

    &:focus {
        outline: 0;
    }
`;

const PlayIcon = styled(dynamic(() => import('icons/Play.svg?react'), { ssr: false }))`
    width: 85px;
    height: 85px;
`;

const StyledTag = styled(Tag)`
    position: absolute;
    top: ${Spacing16};
    left: ${Spacing16};
`;

const GalleryVideoPlayer = ({ video, playing }: { video: IVideo; playing: boolean }) => {
    const { platform, tag, thumbnailUrl } = video;
    const [started, setStarted] = useState(playing);
    const thumbnail = useVideoThumbnail(video.id, platform);

    function renderImage() {
        if (!thumbnailUrl && !thumbnail.data) return null;

        return <StyledImage src={thumbnailUrl || thumbnail.data || ''} alt="" />;
    }

    const handlePlay = () => {
        setStarted(true);
    };

    if (!started) {
        return (
            <Overlay>
                <ImageContainer>
                    {renderImage()}
                    <ButtonContainer>
                        <PlayButton type="button" onClick={handlePlay}>
                            <PlayIcon />
                        </PlayButton>
                    </ButtonContainer>
                </ImageContainer>
                {tag && <StyledTag text={tag} />}
            </Overlay>
        );
    }

    return <VideoPlayer video={video} playing={started} tag={tag} thumbnailUrl={thumbnailUrl} />;
};

export default GalleryVideoPlayer;
